import React from 'react';
import Slide from 'react-reveal/Slide';
import Form from '../Others/Form';
import SocialContactItems from './SocialContactItems';
import styles from './styles.module.scss';

function ContactBox() {
	return (
		<Slide bottom>
			<div className={`box ${styles.contactBox}`} id='form-box'>
				<h1 className='section-title'>Get in touch</h1>
				<Form
					type='Email'
					message='Message'
					button='Submit'
					success='getting in touch'
				/>
				<SocialContactItems className='blackSocialItems' />
			</div>
		</Slide>
	);
}

export default ContactBox;
